import type { FaireProductEntity } from "../../entity_types/product";

export const p_5m2yezq3e7: FaireProductEntity = {
  token: "p_5m2yezq3e7",
  type: "product",
  name: "Skate T-Tool Printed",
  brandToken: "b_9grp69f3nm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6dc83df36d6c76baa4b1d91968d3eac654d7fdc8123b7273e3724af29179a119.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d40d5e0964f56d8ff01071834269cff90ddb950830acbe438b15a1a4c025c235.jpeg",
    "https://cdn.faire.com/fastly/45009deb3a52f29d4071b14ec9f07f44e0111a437ebc39589578757a2dec2c4f.jpeg",
    "https://cdn.faire.com/fastly/50f8e58c7a483c986afbddfdf7be1ca3690796d4672f15e6bd91457967ad554d.jpeg",
    "https://cdn.faire.com/fastly/4a1858ea60ec0437fd00d53459d692bf01a450efb92567d041e2ed013e72d32b.jpeg",
    "https://cdn.faire.com/fastly/8adc18b6cf2069ea336000617c6c85a3f76cab985847aec34dd965c6ea94f735.jpeg",
    "https://cdn.faire.com/fastly/3920283e901ba60418e8f136bbaa9a144c85cae8d5a1a3d97752a289babb08e7.jpeg",
    "https://cdn.faire.com/fastly/d27dac78034b8dfcbc161bfaff269942c2d02c43952da8bd32abcc4e4caaee1c.jpeg",
    "https://cdn.faire.com/fastly/5f07a697eac3e8061f2f8465b0f0a648362d3abaed4547e837cdc565768c2df4.jpeg",
    "https://cdn.faire.com/fastly/19432156f7850c3f0d2587684b093de5bc67b732e455070e3b600fdc4eeff9e5.jpeg",
    "https://cdn.faire.com/fastly/e9e0da16c430757e7620824bfa29e59e8ac6ed4873164907c8a03ede2bb02b32.jpeg",
    "https://cdn.faire.com/fastly/1f39b91330ed2818fed639c75ac6d5cdac042c39b3933b9d183d2c4849625825.jpeg",
    "https://cdn.faire.com/fastly/594d76a3c147f5d8e32f050fce9a6e7285605c01ec4e4f0fc0ba455eddff223d.jpeg",
    "https://cdn.faire.com/fastly/8d03968205030e46a3034216c05d390b1cbf0937ba4d0ef31070624453772b23.jpeg",
  ],
  priceDollars: 9.57,
  description:
    "The Hydroponic T-Tool is a perfect skateboarding tool, T-shaped and with a PVC body, a key element in your backpack anytime you go out to skate.\n\n3 wrenches in 1: Nuts, Trucks, and Kingpin",
  tags: [],
  msrpDollars: 19.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:30.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
